import { render, staticRenderFns } from "./EditAddressModal.vue?vue&type=template&id=0a34c3f6&"
import script from "./EditAddressModal.vue?vue&type=script&lang=js&"
export * from "./EditAddressModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports